import Gravatar from 'react-gravatar';
import React from 'react';
import moment from 'moment';

class ConversationListElement extends React.Component {
    render() {
        return (
            <li onClick={(e) => {e.stopPropagation(); this.props.openChat(this.props.visitor.uid)}} className="list-group-item">
                <div className="media" style={{marginLeft:'10px'}}>
                    <div className="media-left">
                        <a className="avatar" href="javascript:void(0)">
                            <Gravatar email={this.props.visitor.email ? this.props.visitor.email : 'nobody'} size={100} rating="pg" default="identicon" className="img-responsive" />
                        </a>
                    </div>
                    <div className="media-body">
                        <h4 className="media-heading">{this.props.visitor.name ? this.props.visitor.name : 'Unknown'} {    this.props.visitor.online === 0 ? <span className="tag tag-danger delay-rendering" style={{paddingTop:'7px',paddingBottom:'5px'}}>Offline</span>:null}</h4>
                        <small>{this.props.visitor.email ? this.props.visitor.email : 'Unknown'}</small>
                    </div>
                    {
                        this.props.visitor.unreadMessages > 0
                        ?
                            <div className="media-right" style={{verticalAlign:'middle'}}>
                                <span className="tag tag-danger" style={{paddingTop:'7px',paddingBottom:'5px'}}>{this.props.visitor.unreadMessages}</span>
                            </div>
                        :
                        null
                    }

                </div>
            </li>
        );
    }
}

export default ConversationListElement;



// WEBPACK FOOTER //
// ./containers/chat/ConversationListElement.js